import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const FlagFR: React.FC<IIconProps> = ({
  size = IconSizes.md,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 25 25"
      fill="none"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        d="M13.7407 3.781C13.8062 4.37082 15.248 13.808 15.248 13.808L9.94367 14.3267L8.52487 4.65429L13.7407 3.781Z"
        fill="white"
      />
      <path
        d="M8.82547 4.23971C8.891 4.82954 10.3328 14.2667 10.3328 14.2667L5.58306 14.7312L5.02848 14.7855L3.60966 5.11304L4.12909 5.02607L8.82547 4.23971Z"
        fill="#2E50A2"
      />
      <path
        d="M18.918 2.53578C18.9835 3.1256 20.4253 12.5628 20.4253 12.5628L15.121 13.0815L13.7022 3.40911L18.918 2.53578Z"
        fill="#EA3223"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4252 2.25L3 4.65935L3.08502 5.23895C3.086 5.25284 3.08752 5.2668 3.08961 5.2808L3.1953 5.99078L4.57479 15.3951L4.59487 15.3922L5.46094 21.2098C5.50464 21.5034 5.77803 21.7059 6.07158 21.6622C6.36512 21.6185 6.56766 21.3451 6.52396 21.0516L5.65824 15.2362L21 12.9858L19.4252 2.25ZM5.65824 15.2362L5.58306 14.7312L5.02848 14.7855L3.60966 5.11304L4.12909 5.02607C4.04643 4.78608 3.80212 4.63144 3.542 4.67017C3.26245 4.71178 3.06544 4.9617 3.08502 5.23895L3.1953 5.99078L4.59487 15.3922L5.65824 15.2362ZM5.49998 14.1732L19.7807 12.0784L18.5178 3.46934L4.21934 5.56673L4.2585 5.83371L5.49998 14.1732Z"
        fill="#050505"
      />
      <path
        d="M5.02848 14.7855L3.60966 5.11304L4.12909 5.02607C4.04643 4.78608 3.80212 4.63144 3.542 4.67017C3.26245 4.71178 3.06544 4.9617 3.08502 5.23895L3.1953 5.99078L4.59487 15.3922L5.65824 15.2362L5.58306 14.7312L5.02848 14.7855Z"
        fill="#050505"
      />
    </svg>
  );
};

export default FlagFR;
